<template>
  <v-dialog
    :value="show"
    scrollable
    max-width="800px"
    @input="handleInput"
  >
    <v-card>
      <v-toolbar
        flat
        dark
        dense
        color="primary"
      >
        <v-toolbar-title>{{ $t('Support') }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          dark
          @click="$emit('hide')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-6">
        <webcomet-faq
          :faq-id="$page.props.admin_faqs.support"
          webcomet-url="https://app.webcomet.io"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    }
  },

  methods: {
    handleInput(value) {
      if (value === false) {
        this.$emit('hide');
      }
    }
  }
}
</script>